/**	
 * Licensed Materials - Property of IBM	
 * IBM Cognos Products: Cognos Analytics Home (C) Copyright IBM Corp. 2020, 2021
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.	
 */

define([
	'ca-content/content/content'
], function(content) {

	class NavigatorDialog {

		constructor(options) {
			this.glassContext = options.glassContext;
			this.ancestors = (options.viewOptions && options.viewOptions.ancestors) ? options.viewOptions.ancestors : options.ancestors;
			this.isOpen = false;
		}

		open() {
		}

		hide() {
		}

		_getFolderData() {
			if (this.ancestors && this.ancestors.length) {
				const ancestors = this.ancestors.slice();
				const currentFolder = ancestors.pop();
				let folderPathRef = currentFolder && currentFolder.id;
				if (!folderPathRef) {
					// mru and search object doesn't have a valid parent in the view, try fetch the ancestors of the inputObjects
					if (this.viewOptions && this.viewOptions.inputObjects.length > 0) {
						folderPathRef = this.viewOptions.inputObjects[0].id;
					} else {
						return Promise.resolve({ tab: 'teamContent' }); 
					}
				}
				const options = {
					dataType: 'json',
					type: 'GET',
					url: content.ContentServiceUrls.getPathURL(folderPathRef),
					data: {
						'fields': 'type,ancestors'
					}
				};
				return this.glassContext.getCoreSvc('.Ajax').ajax(options).then((objInfo) => {
					const folder = objInfo.data.data[0];
					if (this._isTopLevel(folder)) {
						return {
							tab: folder.type === 'content' ? 'teamContent' : 'myContent'
						};
					} else {
						return {
							tab: folder.ancestors[0].type === 'content' ? 'teamContent' : 'myContent',
							folder: folder.type === 'folder' ? folderPathRef : folder.ancestors.pop().id
						};
					}
				}).catch((error) => {
					this.logger.error('Failed to retrieve objInfo for pathRef=' + folderPathRef, error);
					return Promise.resolve({ tab: 'teamContent' });
				});
			} else {
				return Promise.resolve({ tab: 'teamContent' });
			}
		}

		_isTopLevel(objInfo) {
			return objInfo.ancestors.length > 0 ? objInfo.ancestors.filter(ancestor => (ancestor.type === 'folder' || ancestor.type === 'content' || ancestor.id === '.my_folders')).length === 0 : true;
		}

		closeDialog() {
			this.isOpen = false;
		}

		render() {
		}
	}
	return NavigatorDialog;
});
